"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Permissions = exports.SYSTEM_ROLE_META_FIELDS = exports.BatchAccessLevel = void 0;
exports.hasPermission = hasPermission;
var BatchAccessLevel;
(function (BatchAccessLevel) {
    BatchAccessLevel["FULL_ACCESS"] = "FullAccess";
    BatchAccessLevel["LIMITED_ACCESS"] = "LimitedAccess";
    BatchAccessLevel["ASSIGNED_ONLY"] = "AssignedOnly";
    BatchAccessLevel["NO_ACCESS"] = "NoAccess";
})(BatchAccessLevel || (exports.BatchAccessLevel = BatchAccessLevel = {}));
//includes the role meta info and access levels
exports.SYSTEM_ROLE_META_FIELDS = [
    "roleId",
    "displayName",
    "roleKey",
    "limitedBatchAccess",
    "administrativeLevel",
];
exports.Permissions = {
    workflow: {
        updateInfo: "workflow_updateInfo",
        transition: "workflow_transition",
        editStep: "workflow_editStep",
    },
    clientOrgs: {
        list: "clientOrgs_list",
        create: "clientOrgs_create",
        update: "clientOrgs_update",
        get: "clientOrgs_get",
    },
    clients: {
        create: "clients_create",
        update: "clients_update",
    },
    clientPortal: {
        getOrder: "clientPortal_getOrder",
        syncOrgClient: "clientPortal_syncOrgClient",
    },
    licenses: {
        create: "licenses_create",
        delete: "licenses_delete",
    },
    orders: {
        list: "orders_list",
        get: "orders_get",
        create: "orders_create",
        update: "orders_update",
        updateStatus: "orders_updateStatus",
        delete: "orders_delete",
        repEditClientInfo: "orders_repEditClientInfo",
    },
    sampleInstances: {
        adminList: "sampleInstances_adminList",
        adminGet: "sampleInstances_adminGet",
        analystList: "sampleInstances_analystList",
        analystGet: "sampleInstances_analystGet",
    },
    batches: {
        getDetails: "batches_getDetails",
        listOverview: "batches_listOverview",
        fetchInstances: "batches_fetchInstances",
        adminGenerate: "batches_adminGenerate",
        analystGenerate: "batches_analystGenerate",
        edit: "batches_edit",
        start: "batches_start",
        updateStatus: "batches_updateStatus",
        comment: "batches_comment",
    },
    samples: {
        updateInfo: "samples_updateInfo",
        bulkImport: "samples_bulkImport",
    },
    specs: {
        upload: "specs_upload",
        download: "specs_download",
        delete: "specs_delete",
        move: "specs_move",
        folders: "specs_folders",
        createReading: "specs_create_reading",
        createReadingRowCol: "specs_create_reading_row_col",
    },
    testLabels: {
        list: "testLabels_list",
    },
    users: {
        list: "users_list",
        listAnalysts: "users_listAnalysts",
        create: "users_create",
        update: "users_update",
    },
    tempPassword: {
        generate: "tempPassword_generate",
    },
    logs: {
        search: "logs_search",
    },
};
function hasPermission(role, permission) {
    return Boolean(role[permission]);
}
